import * as React from 'react'
import { SVGProps } from 'react'

const SvgCloseCookiePoliceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M13.5 4.5a.75.75 0 0 0-1.06 0L9 7.94 5.56 4.5A.75.75 0 0 0 4.5 5.56L7.94 9 4.5 12.44a.75.75 0 0 0 1.06 1.06L9 10.06l3.44 3.44a.75.75 0 0 0 1.06-1.06L10.06 9l3.44-3.44a.75.75 0 0 0 0-1.06Z'
      fill='#7A849D'
    />
  </svg>
)

export default SvgCloseCookiePoliceIcon
